import type { IBimRelationshipEdge, IBimRelationshipNode } from '@skystone/shared';

type NodeRole = IBimRelationshipNode['role'];

interface IRoleStyle {
  header: string;
  card: string;
  chip: string;
}

const ROLE_STYLES: Record<NodeRole, IRoleStyle> = {
  fact: {
    header: 'bg-blue-600 text-white',
    card: 'border-blue-300',
    chip: 'bg-blue-100 text-blue-700',
  },
  dim: {
    header: 'bg-green-600 text-white',
    card: 'border-green-300',
    chip: 'bg-green-100 text-green-700',
  },
  other: {
    header: 'bg-slate-500 text-white',
    card: 'border-slate-300',
    chip: 'bg-slate-100 text-slate-700',
  },
};

export function cardinalitySymbol(cardinality: IBimRelationshipEdge['fromCardinality']): string {
  if (cardinality === 'one') return '1';
  if (cardinality === 'many') return '*';
  return '?';
}

export function cardinalityLabel(edge: IBimRelationshipEdge): string {
  const left = cardinalitySymbol(edge.fromCardinality);
  const right = cardinalitySymbol(edge.toCardinality);
  return `${left}:${right}`;
}

export function edgeColor(edge: IBimRelationshipEdge): string {
  if (edge.cardinality === 'one_to_many' || edge.cardinality === 'many_to_one') return '#0f766e';
  if (edge.cardinality === 'one_to_one') return '#1d4ed8';
  if (edge.cardinality === 'many_to_many') return '#9333ea';
  return '#64748b';
}

export function roleStyle(role: NodeRole): IRoleStyle {
  return ROLE_STYLES[role];
}

export function roleLabel(role: NodeRole): string {
  return role;
}
